// Either format the string, or return undefined
// We return undefined because the `DataItem` will return a `-` placeholder by default
export function formatEventFormStringValue<T extends (date: string) => string>(
    value: string | undefined,
    formatter: T
) {
    return value ? formatter(value) : undefined;
}
